import { render, staticRenderFns } from "./addNewRequest.vue?vue&type=template&id=b39980fa&"
import script from "./addNewRequest.vue?vue&type=script&lang=js&"
export * from "./addNewRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports